import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo } from 'react';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import classNames from 'classnames';
import MuiRadio from '@material-ui/core/Radio';
import useStyles from './styles';

var Index = function (props) {
  var _classNames;

  var classes = useStyles(props);

  var helperText = props.helperText,
      hide = props.hide,
      label = props.label,
      formProps = props.formProps,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      children = props.children,
      className = props.className,
      labelPlacement = props.labelPlacement,
      disabled = props.disabled,
      rest = _objectWithoutPropertiesLoose(props, ["helperText", "hide", "label", "formProps", "color", "children", "className", "labelPlacement", "disabled"]);

  if (hide) return null;
  var customClass = classNames(className, classes.checkbox, (_classNames = {}, _classNames[classes[color]] = color, _classNames[classes.disabled] = disabled, _classNames));
  var checkbox = /*#__PURE__*/React.createElement(MuiRadio, _extends({}, rest, {
    className: customClass,
    disabled: disabled
  }));
  if (label || children || formProps) checkbox = /*#__PURE__*/React.createElement(FormControlLabel, _extends({
    disabled: disabled,
    control: checkbox,
    label: label || children,
    labelPlacement: labelPlacement
  }, formProps));
  if (helperText) checkbox = /*#__PURE__*/React.createElement(Tooltip, {
    TransitionComponent: Zoom,
    title: helperText,
    placement: 'bottom'
  }, checkbox);
  return checkbox;
};

export default /*#__PURE__*/memo(Index);